export default __webpack_public_path__ + "static/media/remove-blue.352f63dc.svg";